/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Coverage_TitleInputs */

const en_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const de_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const fr_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const es_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const it_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const nl_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const pl_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const fi_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const da_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

const sv_keyword_optimizer_coverage_title = /** @type {(inputs: Keyword_Optimizer_Coverage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Coverage`)
};

/**
* | output |
* | --- |
* | "Keyword Coverage" |
*
* @param {Keyword_Optimizer_Coverage_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_coverage_title = /** @type {((inputs?: Keyword_Optimizer_Coverage_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Coverage_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_coverage_title(inputs)
	if (locale === "fr") return fr_keyword_optimizer_coverage_title(inputs)
	if (locale === "es") return es_keyword_optimizer_coverage_title(inputs)
	if (locale === "it") return it_keyword_optimizer_coverage_title(inputs)
	if (locale === "nl") return nl_keyword_optimizer_coverage_title(inputs)
	if (locale === "pl") return pl_keyword_optimizer_coverage_title(inputs)
	if (locale === "fi") return fi_keyword_optimizer_coverage_title(inputs)
	if (locale === "da") return da_keyword_optimizer_coverage_title(inputs)
	if (locale === "sv") return sv_keyword_optimizer_coverage_title(inputs)
	return en_keyword_optimizer_coverage_title(inputs)
});